import { fabric } from 'fabric'

fabric.Object.NUM_FRACTION_DIGITS = 8

const originalToObject = fabric.Object.prototype.toObject
const myAdditional = ['name', 'id']

fabric.Object.prototype.toObject = function(additionalProperties: any) {
  return originalToObject.call(this, myAdditional.concat(additionalProperties))
}
